import React, { useState } from 'react';
import './banner.scss';

const DonationButton = ({ href, label, color }) => {
    const [hover, setHover] = useState(false);

    if (!href) return null;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="donation-button"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                color: hover ? '#fff' : color,
                border: `2px solid ${color}`,
                backgroundColor: hover ? color : 'transparent',
            }}
        >
            {label}
        </a>
    );
};

export default DonationButton;
